import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GridState } from "src/models/GridState";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";
import VwVezneMakbuzIzlemeDTO from "src/models/Vezne/MakbuzIzleme/VwVezneMakbuzIzlemeDTO";
import VwVezneMakbuzIzlemeDTOService from 'src/services/Vezne/MakbuzIzleme/VezneMakbuzIzlemeDTO.service';
import { helper } from "src/utils/helper";

// interface IAllDataMakbuz {
//     basTarih: string;
//     bitTarih: string;
//     yetkiliVezne: string;
// }
// export const getAllDataVezneMakbuzIzleme = createAsyncThunk(
//     'VwVezneMakbuzIzlemeDTOService/getAllDataMakbuzIzleme',
//     async (tarih: IAllDataMakbuz) => {
//         const response = await VwVezneMakbuzIzlemeDTOService.getAllDataMakbuzIzleme(tarih);
//         return response
//     }
// );

export const getDetayliArama = createAsyncThunk(
    'VwVezneMakbuzIzlemeDTOService/getDetayliArama',
    async (aramaModel: VwVezneMakbuzIzlemeDTO, thunkAPI) => {
        const response = await VwVezneMakbuzIzlemeDTOService.getDetayliArama(aramaModel);
        return response
    }
);

export interface IMakbuzIzlemeState extends GridState<VwVezneMakbuzIzlemeDTO> {
    searchModel?: VwVezneMakbuzIzlemeDTO;
}

const MakbuzIzlemeSlice = createSlice<IMakbuzIzlemeState, MapReducerPayloads<IMakbuzIzlemeState, {
    setState: IMakbuzIzlemeState
}>>({
    name: 'MakbuzIzlemeState',
    initialState: {
        data: [],
        activeRow: new VwVezneMakbuzIzlemeDTO(),
        searchModel: {
            ...new VwVezneMakbuzIzlemeDTO(),
            tarih: helper.startDate().toString(),
            tarih2: helper.endDate().toString(),
            vezneId: null
        },
        isFetching: true,
    },
    reducers: {
        setState: (state, action) => action.payload
    },
    extraReducers: (builder) => {
        // builder.addCase(getAllDataVezneMakbuzIzleme.pending, (state) => {
        //     state.isLoading = true;
        // });
        // builder.addCase(getAllDataVezneMakbuzIzleme.fulfilled, (state, action) => {
        //     return {
        //         ...state,
        //         data: action.payload.data,
        //         errorMessage: action.payload.errorMessage,
        //         isLoading: false,
        //         isFetching: false
        //     }
        // });
        builder.addCase(getDetayliArama.pending, (state) => {
            state.isLoading = true
        });
        builder.addCase(getDetayliArama.fulfilled, (state, action) => {
            return {
                ...state,
                data: action.payload.data,
                errorMessage: action.payload.errorMessage,
                isLoading: false,
                isFetching: false
            }
        });
    }
})
export default MakbuzIzlemeSlice;